import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

import { UserService } from '../../user.service';
import { Web3Service } from '../../web3.service';
import { ActivationModalService } from '../activation-modal/activation-modal.service';
import { AuthService } from '../auth/auth.service';
import { defs } from '../../defs';
import { Toastr } from '../toastr';
import { NGXLogger } from 'ngx-logger';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
	selector: 'narwhalia-login-modal',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss']
})
export class LoginModalComponent {
	email = new FormControl('', [Validators.required, Validators.email]);

	password = new FormControl('', [Validators.required]);

	loginForm = new FormGroup({
		email: this.email,
		password: this.password
	});

	constructor(
		private authService: AuthService,
		private dialogRef: MatDialogRef<LoginModalComponent>,
		private web3Service: Web3Service,
		private userService: UserService,
		private activationModalService: ActivationModalService,
		private toastr: Toastr,
		private log: NGXLogger
	) {}

	onSubmit() {
		const { email, password } = this.loginForm.value;
		this.authService.login(email, password).subscribe(
			() => this.dialogRef.close(),
			error => this.handleActivation('login', error)
		);
	}

	useMetaMask() {
		this.web3Service.getAddress()
			.then(this.userService.getLoginNonce)
			.then(this.web3Service.signMessage)
			.then(this.authService.loginWithMetaMask)
			.then(() => this.dialogRef.close())
			.catch(error => this.handleActivation('useMetaMask', error));
	}

	handleActivation(method: string, error: any) {
		if (error instanceof HttpErrorResponse) {
			if (error.status === 403 && error.error) {
				const {loginWithActivationToken, email} = error.error[0].params;
				localStorage.setItem(defs.activationToken, loginWithActivationToken);
				this.dialogRef.close();
				this.activationModalService.openActivationModal(email);
			}
		} else {
			this.log.error('LoginModal.' + method, error)
		}
	}

	close() {
		this.dialogRef.close();
	}
}